export default "__VITE_ASSET__Cypntbuu__"